import ApiService from '@/api/api_service';
import {
  ProductCategoryApi,
  ProductApi,
  ProductCategoryStatusApi,
  type ProductCategoryApiPostProductCategoryRequest,
  type ProductCategoryApiPutProductCategoryRequest,
  type ProductApiPostProductRequest,
  type ProductApiPutProductRequest,
  type ProductCategoryStatusApiPostProductCategoryStatusRequest,
  type ProductCategoryStatusApiPutProductCategoryStatusRequest,
} from '@/api/openapi';

export class ProductCategoryApiService extends ApiService {
  productCategoryApi = new ProductCategoryApi(undefined, this.baseUrl, this.httpInstance);
  productApi = new ProductApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getProductCategories() {
    return this.productCategoryApi.getProductCategories();
  }

  async postProductCategory(request: ProductCategoryApiPostProductCategoryRequest) {
    return this.productCategoryApi.postProductCategory(request);
  }

  async putProductCategory(request: ProductCategoryApiPutProductCategoryRequest) {
    return this.productCategoryApi.putProductCategory(request);
  }

  async postProduct(request: ProductApiPostProductRequest) {
    return this.productApi.postProduct(request);
  }

  async putProduct(request: ProductApiPutProductRequest) {
    return this.productApi.putProduct(request);
  }
}

export class ProductCategoryStatusApiService extends ApiService {
  api = new ProductCategoryStatusApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getProductCategoryStatuses() {
    return this.api.getProductCategoryStatuses();
  }

  async postProductCategoryStatus(request: ProductCategoryStatusApiPostProductCategoryStatusRequest) {
    return this.api.postProductCategoryStatus(request);
  }

  async putProductCategoryStatus(request: ProductCategoryStatusApiPutProductCategoryStatusRequest) {
    return this.api.putProductCategoryStatus(request);
  }
}
